import { Button } from "../../../components/ui/Button";
import { useI18n } from "../../../i18n";
import type { BoardStatus, BoardVia } from "../hooks/useBoard";

/**
 * 진짜 보드 연결(4단계) — 왼쪽 칸 아래. 보드 프로그램에 '놀이터에 연결' 블록을 넣어 내려받고 USB 로 꽂은 뒤 누른다(Web Serial 고르기 창).
 * 연결되면 놀이터는 시뮬레이터 대신 보드를 따른다. 길은 둘 — USB(Web Serial · 컴퓨터 · 크롬북) · 블루투스(Web Bluetooth · 안드로이드 크롬도 · lib/ble).
 * 브라우저가 되는 길만 단추를 둔다 — 둘 다 없으면(아이패드 · 파이어폭스) 안내만.
 */
export function BoardPanel({ status, receiving, usb, ble, via, onConnect, onDisconnect }: {
  status: BoardStatus; receiving: boolean; usb: boolean; ble: boolean; via: BoardVia | null;
  onConnect: (how: BoardVia) => void; onDisconnect: () => void;
}) {
  const { t } = useI18n();
  if (status === "unsupported") return <p className="pf-mb__hint" data-testid="fs-mb-board-unsupported">{t("student.microbit.board4.unsupported")}</p>;
  return (
    <div className="pf-mb__board4" data-testid="fs-mb-board" data-state={status}>
      {status === "on" ? (
        <>
          <p className="pf-mb__scene-state" data-testid="fs-mb-board-state">
            {receiving ? t("student.microbit.board4.on") : t(via === "ble" ? "student.microbit.board4.waitingBle" : "student.microbit.board4.waiting")}
          </p>
          <Button variant="ghost" icon="⏏️" onClick={onDisconnect} data-testid="fs-mb-board-disconnect">{t("student.microbit.board4.disconnect")}</Button>
        </>
      ) : (
        <>
          {usb ? <Button variant="accent" icon="🔌" disabled={status === "connecting"} onClick={() => onConnect("usb")} data-testid="fs-mb-board-connect">{t("student.microbit.board4.connect")}</Button> : null}
          {ble ? <Button variant={usb ? "ghost" : "accent"} icon="📶" disabled={status === "connecting"} onClick={() => onConnect("ble")} data-testid="fs-mb-board-connect-ble">{t("student.microbit.board4.connectBle")}</Button> : null}
          <p className="pf-mb__hint">{status === "failed" ? t("student.microbit.board4.failed") : t("student.microbit.board4.how")}</p>
          {ble ? <p className="pf-mb__hint" data-testid="fs-mb-board-how-ble">{t("student.microbit.board4.howBle")}</p> : null}
        </>
      )}
    </div>
  );
}
